import { render } from "./DetailsView.vue?vue&type=template&id=2853ddad&scoped=true"
import script from "./DetailsView.vue?vue&type=script&lang=js"
export * from "./DetailsView.vue?vue&type=script&lang=js"

import "./DetailsView.vue?vue&type=style&index=0&id=2853ddad&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2853ddad"

export default script